import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect/es';

import { TeacherTeacherInsertLiveClassGroupMutationVariables } from '@school_ify/schoolify-repository/src/teacher/types';

import LiveClassGroups from '../../domain/services/bbb/meeting/liveClassGroups';

const initialState = {
  loading: '',
  error: '',
  groups: [],
};

export const createGroupsForTeacherByLesson = createAsyncThunk(
  'create-groups-for-teacher-by-lesson-id',
  async (model: TeacherTeacherInsertLiveClassGroupMutationVariables) => {
    return new LiveClassGroups().createLiveClassGroup(model);
  }
);

const TeacherCreateGroupsSlice = createSlice({
  name: 'teacher-groups-live-class/create',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(createGroupsForTeacherByLesson.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(createGroupsForTeacherByLesson.fulfilled, (state, action) => {
      state.loading = 'success';
      // @ts-ignore
      state.groups = action.payload;
    });
    builder.addCase(createGroupsForTeacherByLesson.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
  },
});

const stateExport = state => state.teacherCreateGroupsSlice;

export const teacherCreateGroupState = createSelector(stateExport, obj => {
  return {
    loadingGroupLoading: obj.loading,
  };
});

export default TeacherCreateGroupsSlice.reducer;
